<template>
  <el-row class="pengdingMyOrders">
    <el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>工单搜索</span>
        </div>
        <div class="text item">
          <el-form :inline="true" ref="orderForm" :model="orderForm" size="small">
            <el-form-item label="输入查询：" prop="sn">
              <el-input clearable v-model="orderForm.sn" placeholder="请输入工单号"></el-input>
            </el-form-item>
            <el-form-item label="产品型号" prop="goods_model">
              <el-select
                v-model="orderForm.goods_model"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请输入型号关键词"
                :remote-method="remoteMethod"
                :loading="modelLoading">
                <el-option
                  v-for="item in modelOptions"
                  :key="item.id"
                  :label="item.model"
                  :value="item.model">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单类型：" prop="type">
              <el-select v-model="orderForm.type" clearable>
                <el-option v-for="item in datatype" :label="item.text" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="所属部门：" prop="depart_id">
              <el-select v-model="orderForm.depart_id">
                <el-option v-for="item in part" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="工单状态：" prop="status">
              <el-select v-model="orderForm.status" clearable>
                <el-option v-for="item in statusArr" :label="item.text" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间：" prop="time">
              <el-date-picker v-model="orderForm.time" value-format="timestamp" format="yyyy 年 MM 月 dd 日" unlink-panels
                type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('orderForm')" @sub="sub()">查询</el-button>
              <!-- <el-button type="primary" @click="departmentDD">查询2</el-button> -->
              <el-button @click="resetForm('orderForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <div class="tables">
          <div class="mains">
              <el-table border :data="tableData" style="width: 100%"
              @cell-click="cellClick">
                <el-table-column
                        prop="title"
                        label="标题"
                        class-name="snLabel"
                        >
                        <template slot-scope="scope">
                          <!-- <el-badge :is-dot="scope.row.is_update == 0?false:true" class="item"> {{ scope.row.title }}</el-badge> -->
                          <el-badge  :value="scope.row.is_update == 0?'':'new'" class="item">
                            <div size="small">{{ scope.row.title }}</div>
                          </el-badge>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="goods_model"
                        label="产品型号"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="last_reply_content"
                        label="最新回复"
                        >
                        <template slot-scope="scope">
                            <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;">{{ scope.row.last_reply_content == ''?'':scope.row.timeDivision }} {{ scope.row.last_update_person }} {{ scope.row.last_reply_content == ''?'':':' }} {{ scope.row.status == "已完结"?"已完结":scope.row.last_reply_content }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="status"
                        label="状态"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="type"
                        label="工单类型"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="reminder_count"
                        label="催单次数"
                        >
                      </el-table-column>
                      <el-table-column 
                        prop="create_person" 
                        label="工单发起人"
                      >
                      </el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button @click="lookOver(scope.row)" type="text" size="small">查看</el-button>
                    <!-- <el-button type="text" size="small" v-if="scope.row.status !== '已退回' && (scope.row.status !== '待归档' && scope.row.status !== '已完结')">
                      <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                        icon-color="#66b1ff" title="您确认退回该工单么？" @confirm="backClick(scope.row)" @cancel="cancelEvent">
                        <el-button slot="reference" type="text" size="small">退回</el-button>
                      </el-popconfirm>
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
          </div>
          <div class="pages">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" @current-change="currentClick">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </el-row>
  </el-row>
</template>

<script>
import { getOrderType, getOrderSearch, getOrderAccept, orderBack,getOrstatus,getMineAcceptTable,departTable,getMyOrderSearch,getMineAcceptSearch,modelSelect } from '../../utils/api'
import dd from 'dingtalk-jsapi'
export default {
  components: {},
  props: {},
  data() {
    return {
      total: 0,
      page:1,
      pageSize:10,
      orderForm: {
        sn: '',
        type: '',
        time: '',
        status: '',
        goods_model:''
        // depart_id: ''
      },
      tableData: [],
      datatype: [],
      statusArr: [],
      part: [],
      modelLoading:false,
      modelOptions:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
    //获取工单类型
    getOrType() {
      var that = this
      that.datatype = []
      getOrderType()
        .then(res => {
          console.log(res, '工单');
          res.data.forEach(item => {
            that.datatype.push({ text: item.type, value: item.type })
          })
        })
    },
    //获取工单状态列表
    getOrderStatus(){
      var that = this
      getOrstatus()
      .then(res=>{
        if(res.message.status == 'success'){
            that.statusArr = res.data.list
            that.statusArr.forEach(item=>{
              item['text'] = item.title
            })
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },

    //催单
    handleClick(row) {
      console.log(row);
    },
    //查看
    lookOver(row) {
      console.log(row, 'row');
      var that = this
      // this.$router.push('/pendOrderDetail?jumpId='+(row.id))
      this.$router.push('/orderDetail/orderDetail?jumpId='+(row.id))
    },
    //取消受理
    cancelEvent() {
      console.log('取消了');
    },
    //退回工单
    backClick(row) {
      console.log('退回');
      var that = this
      var params = {
        order_id: row.id
      }
      orderBack(params)
        .then(res => {
          console.log(res, '退回工单');
          if(res.message.status == 'success'){
              that.$message.success(res.message.text)
              that.getOrders()
          }else{
            that.$message.error(res.message.text)
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //获取顶级分类
    getDepartTable(){
      departTable()
      .then(res=>{
        console.log(res,'获取顶级分类');
        if(res.message.status == 'success'){
          this.part = res.data
        }else{
          this.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },

    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //查询
    submitForm() {
      // this.$refs.orderTable.submitForm()
      var that = this
      var times = that.orderForm.time
      if(times == ''){
        times = null
      }
      if(Array.isArray(times) && times[0] === ''){
        times = null
      }
      var params = {
        page: that.page,
        pagesize: that.pageSize,
        // depart_id: that.orderForm.depart_id,
        sn: that.orderForm.sn,
        status:that.orderForm.status,
        type: that.orderForm.type,
        goods_model:that.orderForm.goods_model,
        begin_time: times == null?'':times[0] / 1000,
        end_time: times == null?'':times[1] / 1000
      }
      getMineAcceptSearch(params)
        .then(res => {
          console.log(res, 'res');
          if (res.message.status == 'success') {
            that.tableData = res.data
            that.tableData.forEach(item=>{
              var arr = item.last_update_person.split('/')
              var personArr = item.create_person.split('/')
              item.last_update_person = arr[arr.length-1]
              item.create_person = personArr[personArr.length-1]
              item["timeDivision"] = that.initTimeship(item.last_reply_time)
          })
            that.getStatus(that.tableData)
            that.total = res.total
          }else{
            that.tableData = []
            that.total = 0
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    //当前页
    currentClick(e) {
      var that = this
      that.page = e
      if (that.orderForm.sn !== '' || that.orderForm.type !== '' || (that.orderForm.time !== null && that.orderForm.time !== '') || that.orderForm.depart_id !== '' || that.orderForm.status !== '') {
        that.submitForm()
      } else {
        that.getOrders()
      }
      console.log(that.orderForm, 'orderForm');
    },
    //我的工单
    getOrders() {
      var that = this
      var params = {
        page: that.page,
        pagesize: that.pageSize
      }
      getMineAcceptTable(params)
        .then(res => {
          console.log(res, '我的工单');
          if(res.message.status == 'success'){
            that.tableData = res.data
            that.tableData.forEach(item=>{
              var arr = item.last_update_person.split('/')
              var personArr = item.create_person.split('/')
              item.last_update_person = arr[arr.length-1]
              item.create_person = personArr[personArr.length-1]
              item["timeDivision"] = that.initTimeship(item.last_reply_time)
            })
            that.getStatus(that.tableData)
            that.total = res.total
          }else{
            that.tableData = []
          }
        })
        .catch(err => {
          console.log(err, 'err');
        })
    },
    cellClick(row, column, cell, event){
      console.log(cell,'cell');
      console.log(row,'row');
      if(column.label == '标题'){
          // this.$router.push('/pendOrderDetail?jumpId='+(row.id))
          this.$router.push('/orderDetail/orderDetail?jumpId='+(row.id))
      }
    },
    //时间戳转时、分、秒
    initTimeship(time){
      const date = new Date(time * 1000)
      const Y = date.getFullYear()
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const D = date.getDate()
      const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return `${h}:${m}`
    },
    //型号模糊查询触发
    remoteMethod(value){
      console.log('促发了');
      this.modelOptions = []
      if(value !== ''){
        this.modelLoading = true;
        var params = {
          model:value
        }
        modelSelect(params)
        .then(res=>{
          console.log(res,'模糊查询结果');
          if(res.message.status == 'success'){
            this.modelOptions = res.data
            this.modelLoading = false
          }else{
            this.modelLoading = false
            this.$message.error(res.message.text)
          }
        })
        .catch(err=>{
          this.$message.error(err)
          this.modelLoading = false
          console.log(err);
        })
      }else{
        this.modelOptions = []
      }
    },


  },
  created() { },
  mounted() {
    this.getOrType();
    this.getOrderStatus()
    // this.getDepartTable()
  },
  activated(){
    this.getOrders()
    this.submitForm()
  }
};
</script>
<style lang="scss" scoped>
.pages{
  text-align: right;
  margin-top: 20px;
}

.mains{
  ::v-deep  .snLabel{
    color: #409EFF;
    margin: 10px 0;
    div:hover{
      // border-bottom: 2px solid #65afec;
      cursor: pointer;
    }
    // .el-badge__content.is-fixed{
    //       position: unset;
    //       -webkit-transform: none;
    //       transform: none;
    //   }
    .cell{
    padding-top: 10px;
    padding-right: 30px;
  }
  }

  ::v-deep .is-leaf{
    color: #666 !important;
    div:hover{
      border-bottom: none;
    }
  }
}
</style>